<template>
  <div class="navbar-container">
    <img :src="require('../assets/EENLogo.png')">
    <span
      v-if="version"
      class="navbar-container__version"
    >v{{ version }}</span>
    <div class="navbar-container__horizontal-line" />
  </div>
</template>

<script setup lang="ts">
declare const config: { version?: string };

const version = typeof config !== 'undefined' ? config.version : '';
</script>

<style lang="scss" scoped>
@import "@/styles/public/main.scss";

.navbar-container {
  width: 100%;
  height: 6rem;
  display: grid;
  place-items: center;
  padding: 1rem;
  padding-bottom: 0;
  position: relative;

  &__version {
    position: absolute;
    right: 1rem;
    top: 1rem;
    font-size: 11px;
    color: $secondaryMedium;
    font-family: Roboto, sans-serif;
  }

  &__horizontal-line {
    width: 100%;
    border: 1px solid $primaryElements;
    margin-top: 1rem;
  }
}
</style>
